import React from 'react';
import styles from './planCard.module.css';
import { getTextStyles } from '../../../utils/textStyleUtils';

export interface Plan {
  id: string;
  validityValue: {
    text: string;
    style?: {
      textColor?: string;
      textStyle?: string;
    };
  };
  planValue: {
    text: string;
    style?: {
      textGradientColors?: string;
      textStyle?: string;
      gradientAngle?: number;
    };
  };
  strikePrice: {
    text: string;
    style?: {
      textStyle?: string;
      textColor?: string;
      isStrikeThrough?: boolean;
    };
  };
  actualPriceAmount: number;
  actualPrice: {
    text: string;
    style?: {
      textGradientColors?: string;
      textColor?: string;
      textStyle?: string;
    };
  };
  isSelected: boolean;
  timeline: {
    startDate: string;
    endDate: string;
  };
  tag?: string;
}

interface PlanCardProps {
  plan: Plan;
  planBorderColor?: string;
  planBgColor?: string;
  selectedPlanColor?: string;
  onSelect?: (planId: string) => void;
}

const PlanCard: React.FC<PlanCardProps> = ({
  plan,
  planBorderColor = '#000000',
  planBgColor = '#22242B',
  selectedPlanColor = '#AC87F3',
  onSelect,
}) => {
  const handleClick = () => {
    if (onSelect) {
      onSelect(plan.id);
    }
  };

  return (
    <div
      className={`${styles.planCardWrapper} ${plan.isSelected ? styles.selected : ''}`}
      onClick={handleClick}
    >
      <div className={styles.planCard}>
      <div className={styles.planHeader}>
        <div className={styles.priceContainer}>
          <span
            className={styles.actualPrice}
            style={getTextStyles(plan.actualPrice.style)}
          >
            {plan.actualPrice.text}
          </span>
          {plan.strikePrice && (
            <span
              className={styles.strikePrice}
              style={getTextStyles(plan.strikePrice.style)}
            >
              {plan.strikePrice.text}
            </span>
          )}
        </div>
        <div className={styles.perDayBadge}>
          <span
            className={styles.perDayText}
            style={getTextStyles(plan.planValue.style)}
          >
            {plan.planValue.text}
          </span>
        </div>
      </div>
      <div className={styles.planFooter}>
        <span
          className={styles.validityText}
          style={getTextStyles(plan.validityValue.style)}
        >
          {plan.validityValue.text}
        </span>
        {plan.tag && (
          <div className={styles.tag}>
            {plan.tag}
          </div>
        )}
      </div>
    </div>
    </div>
  );
};

export default PlanCard;

